import { render, staticRenderFns } from "./StagedFileCard.vue?vue&type=template&id=26f9be33&"
import script from "./StagedFileCard.vue?vue&type=script&lang=js&"
export * from "./StagedFileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f9be33')) {
      api.createRecord('26f9be33', component.options)
    } else {
      api.reload('26f9be33', component.options)
    }
    module.hot.accept("./StagedFileCard.vue?vue&type=template&id=26f9be33&", function () {
      api.rerender('26f9be33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/knowledgeBase/StagedFileCard.vue"
export default component.exports